import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@/Components/Icon/Icon';
export const WarningCircle = () => {
    return (_jsx("button", { className: 'peer flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-warning text-warning-contrast', children: _jsx(Icon, { type: 'warning', size: "small" }) }));
};
